var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',[_c('source',{attrs:{"srcset":_vm.src,"media":"(min-width: 1200px)"}}),_c('source',{attrs:{"srcset":_vm.src,"media":"(min-width: 768px)"}}),_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }